<template>
  <div>
    <vl-grid v-if="fetching" v-vl-spacer:top.large>
      <vl-column key="loading" v-vl-align:center>
        <vl-loader message="Bezig met ophalen gegevens" />
      </vl-column>
    </vl-grid>
    <vl-alert v-else-if="paredError" v-vl-spacer:top.large icon="alert-circle" mod-warning :title="paredError.title">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="paredError.message" />
      <template v-slot:actions>
        <vl-button v-if="modRetry" icon="text-redo" mod-icon-before mod-large @click="reload"
          >Opnieuw proberen</vl-button
        >
        <vl-button v-if="redirect" mod-large @click="redirectTo">{{ redirectMessage }}</vl-button>
      </template>
    </vl-alert>
    <slot v-else />
  </div>
</template>

<script lang="ts" src="./dl-alert-page.ts" />
